import { TIME_DISTRIBUTION } from "@/constants";
import type { DataMode } from "@/constants";
import { FAMILY } from "@/settings/widgetFamilies";

export default {
  family: [FAMILY.OTHER],
  recommendedFamily: [FAMILY.OTHER],
  name: "",
  title: "Budget Allocation",
  defaultHeight: 8,
  planOnly: true,
  dataModes: ["project"] as DataMode[],
  settings: {},
  widgetSettings: {
    widget: "DataTable",
  },
  planSettings: {
    granularity: {
      default: "month",
      type: "select",
      label: "Granularity",
      dictionary: "timeGranularity",
      gridPosition: [0, 0],
    },
    distribution: { default: TIME_DISTRIBUTION },
    columns: {
      default: [
        {
          title: "Campaign ID",
          value: "campaign_id",
        },
        {
          title: "Business Goal",
          value: "business_goal",
        },
        {
          title: "Plan",
          value: "plan",
        },
        {
          title: "Geography",
          value: "geography",
        },
        {
          title: "Channel",
          value: "channel",
        },
        {
          title: "Campaign KPI",
          value: "campaign_kpi",
        },
        {
          title: "Budget",
          value: "budget",
        },
      ],
    },
  },
};
